import { Pipe, PipeTransform } from '@angular/core';
import { EFormService } from '../e-forms/e-form.service';

@Pipe({
  name: 'getControlImage'
})
export class GetControlImagePipe implements PipeTransform {

  constructor(private eFormService: EFormService) {}

  transform(controlType: string, args?: any): any {
    if (controlType == this.eFormService.controlTypes.buttons) {
      return 'ebutton buttons.png';
    }
    else if (controlType == this.eFormService.controlTypes.checkboxWithTextbox) {
        return 'ebutton check text.png';
    }
    else if (controlType == this.eFormService.controlTypes.checkbox) {
        return 'ebutton checkbox.png';
    }
    else if (controlType == this.eFormService.controlTypes.date) {
        return 'ebutton date.png';
    }
    else if (controlType == this.eFormService.controlTypes.divider) {
        return 'ebutton divider.png';
    }
    else if (controlType == this.eFormService.controlTypes.verticalDivider) {
        return 'ebutton vertical divider.png';
    }
    else if (controlType == this.eFormService.controlTypes.dropdown) {
        return 'ebutton dropdown.png';
    }
    else if (controlType == this.eFormService.controlTypes.image) {
        return 'ebutton image.png';
    }
    else if (controlType == this.eFormService.controlTypes.note) {
        return 'ebutton multi line.png';
    }
    else if (controlType == this.eFormService.controlTypes.radioButtons) {
        return 'ebutton radio.png';
    }
    else if (controlType == this.eFormService.controlTypes.textbox) {
        return 'ebutton text field.png';
    }
    else if (controlType == this.eFormService.controlTypes.text) {
        return 'ebutton text.png';
    }
    else if (controlType == this.eFormService.controlTypes.attachment) {
        return 'ebutton attachment.png';
    }
    else if (controlType == this.eFormService.controlTypes.linkToFile) {
        return 'ebutton link.png';
    }
    else if (controlType == this.eFormService.controlTypes.linkToFile) {
        return 'ebutton link.png';
    }
    else if (controlType == this.eFormService.controlTypes.component) {
        return 'ebutton custom template.png';
    }
    else if (controlType == this.eFormService.controlTypes.time) {
        return 'ebutton time.png';
    }
    else {
        return '';
    }
  }

}
